export * from './offer-card'
